import parking_icon from "../static/icons/parking_sign_white.png";
import service_icon from "../static/icons/service_sign_white.png";
import pumptrack_icon from "../static/icons/bicycle_pumptrack.png";
import training_icon from "../static/icons/bicycle_training_station.png";
import bike_pump_icon from "../static/icons/bikce_compressor_icons.png";
import nextbike_icon from "../static/icons/nextbike_white.png";

export type LayerControlDefinition = {
  id: string;
  name: string;
  icon: string;
  symbol: string;
  group: "map" | "point";
};

//To generate buttons
export const layerIDs: LayerControlDefinition[] = [
  // {id: "POI", name: "POI", icon: ""},
  {id: "Routes", name: "szlaki rowerowe", icon: "", symbol: "SZ", group: "map"},
  {id: "ways", name: "drogi rowerowe", icon: "", symbol: "DR", group: "map"},
  {id: "shape", name: "obrys miasta", icon: "", symbol: "OB", group: "map"},
  // {id: "GPX", name: "drogi GPX", icon: ""},
  // {id: "Pahts", name: "Ścieki", icon: ""},
  {id: "Nextbike", name: "stacje Metrorower", icon: nextbike_icon, symbol: "MR", group: "point"},
  {id: "Parkings", name: "parkingi rowerowe", icon: parking_icon, symbol: "PR", group: "point"},
  {id: "RepairStations", name: "stacje naprawy", icon: service_icon, symbol: "SN", group: "point"},
  {id: "BikePumps", name: "pompowanie", icon: bike_pump_icon, symbol: "PO", group: "point"},
  {id: "Pumptracks", name: "pumptracki", icon: pumptrack_icon, symbol: "PT", group: "point"},
  {id: "TrainingStations", name: "miasteczka rowerowe", icon: training_icon, symbol: "MR", group: "point"}
];
